export default {"src":"/_next/static/media/search-light.4d1fd3e9.svg","height":18,"width":19,"blurWidth":0,"blurHeight":0};